'use client';

import { FloatingArrow, useMergeRefs } from '@floating-ui/react';
import { forwardRef, useContext } from 'react';

import { css, cx } from '@/styled-system/css';

import { TooltipRootContext } from './context/tooltip-root.context';
import { tooltipArrowStyles } from './styles/tooltip-arrow.styles';
import type { TooltipArrowPropsInterface } from './types/tooltip-arrow.types';

/**
 * @since 10.0.0
 */
export const TooltipArrow = forwardRef<SVGSVGElement, TooltipArrowPropsInterface>(
  (props: TooltipArrowPropsInterface, forwardedRef) => {
    const { tooltip } = useContext(TooltipRootContext);
    const { className, css: cssProp, width = 24, height = 14, tipRadius = 1, ...rest } = props;

    const styles = css(tooltipArrowStyles, cssProp);

    const mergedRefs = useMergeRefs([tooltip.arrowRef, forwardedRef]);

    return (
      <FloatingArrow
        ref={mergedRefs}
        data-c11n-version={__C11N_VERSION__}
        data-c11n-component="Tooltip.Arrow"
        className={cx('c11n', styles, className)}
        width={width}
        height={height}
        tipRadius={tipRadius}
        context={tooltip.context}
        {...rest}
      />
    );
  },
);

TooltipArrow.displayName = 'Tooltip.Arrow';
